import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { bimRemoveActKC2OtherGql } from '../../bimWorkOrderQueries';

const requestId = 'bimRemoveActKC2Other';

export const useBimRemoveActKC2Other = (onSuccess: () => void) => {
    const dispatch = useDispatch();
    const [bimRemoveActKC2OtherReset] = useResetStoreData({ requestId });

    const [, bimRemoveActKC2OtherStatus, , bimRemoveActKC2OtherRequest] = useRequest({
        requestId,
        query: bimRemoveActKC2OtherGql,
        withEffect: false,
        dependenciesUpdater: onSuccess,
    });

    useEffect(() => {
        bimRemoveActKC2OtherReset(null);
    }, [bimRemoveActKC2OtherReset]);

    const bimRemoveActKC2OtherMakeRequest = useCallback(
        (actKC2OtherId: number) => {
            dispatch(bimRemoveActKC2OtherRequest({ actKC2OtherId }));
        },
        [bimRemoveActKC2OtherRequest, dispatch],
    );

    return {
        bimRemoveActKC2OtherStatus,
        bimRemoveActKC2OtherMakeRequest,
    };
};
